module.exports = __webpack_public_path__ + "static/receptionist-always-live-732b2578048520fed7549bf6d7913a8d.jpg";